/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState } from 'react'
import { Checkbox, Input, InputNumber } from 'antd'
import { BROOKFIELD_CLIENT } from 'client'
import { Labeled, SubDiv } from './Card97EditAntd'
import TextArea from 'antd/lib/input/TextArea'
import SpillTable from './SpillTable'
import { freeEditEngine } from '@integec/grid-tools'
import moment from 'moment'
import { getUnits, timeZoneIdentMap } from 'core'
import { connect } from 'react-redux'
const BKFCard97Extension = ({
  data = {},
  // spec = {},
  handleExtSave,
  handleChange,
  // CLIENT,
  // disableComp,
  allData,
  units,
  mode,
  disableComp,
  disableCOPUEVentTypeView,
}) => {
  const { extendedDes, string1 } = data
  const { eventType } = allData

  return (
    <div>
      <SubDiv style={{ marginTop: '10px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '20px auto' }}>
          <Checkbox
            disabled={disableComp}
            style={{ width: '100%' }}
            key="string1"
            // disabled={disableComp && eventType !== 'PD' && eventType !== 'PO'}
            checked={string1 === 'Y'}
            placeholder="Budgeted Actual"
            name="string1"
            onChange={e =>
              handleExtSave('string1', e.target.checked ? 'Y' : 'N')
            }
          />
          <div
            css={{
              marginTop: '0px',
              alignSelf: 'center',
              fontWeight: '500',
              marginLeft: '5px',
            }}
          >
            Budgeted Actual
          </div>
        </div>
      </SubDiv>
      {(mode === 'E' || mode === 'D') && (
        <SubDiv style={{ marginTop: '10px' }}>
          <Labeled>Modification Reason</Labeled>
          <TextArea
            disabled={disableComp}
            row={5}
            style={{ width: '100%' }}
            key="extendedDes"
            // disabled={disableComp}
            name="extendedDes"
            value={extendedDes}
            onChange={e => handleExtSave('extendedDes', e.target.value)}
          />
        </SubDiv>
      )}
      <SpillTable
        data={data}
        allData={allData}
        handleChange={handleChange}
        handleExtSave={handleExtSave}
        mode={mode}
        disableComp={disableComp}
        disableCOPUEVentTypeView={disableCOPUEVentTypeView}
      />
    </div>
  )
}

export default BKFCard97Extension
